export * from "./jira-service-management-pricing-page.template";
export { JiraServiceManagementPricingPageTemplate as default } from "./jira-service-management-pricing-page.template";
